import BaseDecorator from "./BaseDecorator";

export default class AttachmentDecorator extends BaseDecorator {
  constructor(data) {
    super({
      ...data,
      name: data.name || null,
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/AttachmentDecorator.js